import React from 'react';

const ProjectCard = ({ project, onSelect }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Completed': return 'bg-green-100 text-green-800';
      case 'In Progress': return 'bg-blue-100 text-blue-800';
      case 'Planning': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer overflow-hidden"
      onClick={() => onSelect(project)}
    >
      <img 
        src={project.image} 
        alt={project.title}
        className="w-full h-48 object-cover"
      />
      <div className="p-6">
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-lg font-bold text-gray-900">{project.title}</h3>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(project.status)}`}>
            {project.status}
          </span>
        </div>
        <p className="text-gray-600 text-sm mb-4">{project.location}</p>
        <div className="flex justify-between text-sm text-gray-500 mb-4">
          <span>Type: {project.type}</span>
        </div>
        <p className="text-gray-700 text-sm line-clamp-2">{project.description}</p>
        <button className="mt-4 text-blue-600 hover:text-blue-800 font-medium text-sm">
          View Details →
        </button>
      </div>
    </div>
  );
};

export default ProjectCard;